export enum AppointmentRequestTypeFilter {
  All = 'All',
  AppointmentRequests = 'AppointmentRequests',
  Rescheduling = 'Rescheduling',
  Cancellation = 'Cancellation',
  Standard = 'Standard',
  DirectScheduled = 'DirectScheduled'
}
